import React, { useState, useEffect, useCallback } from 'react';

// カスタムフック
import { useFetchDataWithInit } from 'hooks/useFetchData';
import { useSnackBar } from 'hooks/useSnackBar';

/**
 * 販売区分を取得するカスタムフック
 */
export const useGetSalesCategory = () => {
  const [salesCategoryList, setSalesCategoryList] = useState([]); //フィルタリングした後の列データ

  const url = `${process.env.REACT_APP_API_URL}/FILMa_GetSalesCategory?code=${process.env.REACT_APP_API_CODE}`;

  // カスタムフック
  const { data, error, isLoading, reacquireData } = useFetchDataWithInit(url, []);
  const { toggleSnack } = useSnackBar();

  useEffect(() => {
    if (!data) return;
    let status = 'success';
    let message = '販売区分の取得に失敗しました。';
    if (!data.code) {
      // 成功時
      setSalesCategoryList(data.result);
    } else {
      // 失敗時
      status = 'error';
      // if (data.code === 'E0220') {
      //   status = 'info';
      //   message = 'データの登録がありません';
      // }
      toggleSnack(true, status, message);
    }
  }, [data]);

  // エラーの場合
  useEffect(() => {
    if (!error) return;
    toggleSnack(true, 'error', '販売区分の取得に失敗しました。');
  }, [error]);

  return {
    salesCategoryList,
  };
};
